import { gql } from '@apollo/client'
import { useCustomMutation } from 'utils/mutations'

// CLAIM_UPDATE

const mutation = gql`
  mutation claimUpdate(
    $id: ID!
    $attributes: ClaimUpdateAttributesInput
    $include_archived: Boolean = false
    $include_admin_notes: Boolean = false
    $include_amount_saved: Boolean = false
    $include_date_of_service: Boolean = false
    $include_request_notes: Boolean = false
    $include_insurance_carrier: Boolean = false
    $include_insurance_member_id: Boolean = false
    $include_group_id: Boolean = false
    $include_focus_request: Boolean = false
    $include_focus_request_other: Boolean = false
    $include_originally_billed: Boolean = false
  ) {
    claimUpdate(id: $id, attributes: $attributes) {
      id
      archived @include(if: $include_archived)
      admin_notes @include(if: $include_admin_notes)
      amount_saved @include(if: $include_amount_saved)
      date_of_service @include(if: $include_date_of_service)
      request_notes @include(if: $include_request_notes)
      insurance_carrier @include(if: $include_insurance_carrier)
      insurance_member_id @include(if: $include_insurance_member_id)
      group_id @include(if: $include_group_id)
      focus_request @include(if: $include_focus_request)
      focus_request_other @include(if: $include_focus_request_other)
      originally_billed @include(if: $include_originally_billed)
    }
  }
`

export default function useClaimUpdate(successMessage = 'Claim is updated') {
  const { onMutate: onClaimUpdate, loading } = useCustomMutation({
    mutation,
    successMessage,
    responsePath: 'claimUpdate'
  })
  return { onClaimUpdate, loading }
}
